var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 67,
    viewBox: "0 0 77 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 67L38.5 0L77 67H0ZM70.6567 63.3167L38.5 7.36668L6.34333 63.3167H70.6567ZM36.6667 41.2166V26.4832H40.3333V41.2166H36.6667ZM36.6667 48.5833H40.3333V55.95H36.6667V48.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon2);
export default __webpack_public_path__ + "static/media/service_icon-2.6cccb9ca52b8d43776749f39f2a24beb.svg";
export { ForwardRef as ReactComponent };